import { Backdrop } from "@mui/material";

/**
 * 
 * The BlurLayout component is used to provide emphasis on a particular element or parts of it.
 * 
 * The BlurLayout signals to the user of a state change within the application and can be used for creating loaders, dialogs, and more. In its simplest form, the BlurLayout component will add a dimmed layer over your application.
 * 
* ###Import to use it
*
*```jsx
*   import { BlurLayout } from '@eco/react-lib'
*```
*
*### Usage
*
*```jsx
*<BlurLayout 
*  isActivated={boolean} 
/>
*```
*
*### Basic Example
*/


export const BlurLayout = ({ isActivated, children } : BlurLayoutType) => {
    return (
        <Backdrop open={isActivated} style={{ zIndex: 999 }}>
            { children }
        </Backdrop>
    )
}

type BlurLayoutType = {
    children: React.ReactNode
    isActivated: boolean,
}